import { JournalId } from 'types';

export const GROUP_DAILY_ATTENDANCE = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/group-attendance/daily`;

export const GROUP_MONTHLY_ATTENDANCE = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/group-attendance/monthly`;
